module.exports = __webpack_public_path__ + "img/restore.1d853eb9.png";